import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const MainContainer = styled.div`
  ${() => {
    const {
      tokens: { slider },
    } = useDesignTokens();

    return css`
      width: 100%;

      .react-aria-Slider {
        display: grid;

        .react-aria-SliderTrack {
          position: relative;

          &:before {
            content: "";
            display: block;
            position: absolute;
          }
        }

        .react-aria-SliderThumb {
          width: ${slider.thumb.size};
          height: ${slider.thumb.size};
          border-radius: 50%;
          forced-color-adjust: none;

          &[data-focus-visible] {
            outline: ${slider.thumb.focusRing.width} solid
              ${slider.thumb.focusRing.color};
            outline-offset: ${slider.thumb.focusRing.offset};
          }
        }

        &[data-orientation="horizontal"] {
          flex-direction: column;

          .react-aria-SliderTrack {
            height: ${slider.thumb.size};
            width: 100%;

            &:before {
              height: ${slider.track.size};
              width: 100%;
              top: 50%;
              transform: translateY(-50%);
              background: ${slider.track.color};
              border-radius: ${slider.track.size};
            }
          }

          .react-aria-SliderThumb {
            top: 50%;
            cursor: pointer;

            & [data-primary-color] {
              color: ${slider.thumb.primaryColor.base};
            }

            & [data-secondary-color] {
              color: ${slider.thumb.secondaryColor.base};
            }

            &:hover [data-primary-color] {
              color: ${slider.thumb.primaryColor.hover};
            }

            &:hover [data-secondary-color] {
              color: ${slider.thumb.secondaryColor.hover};
            }

            &:active [data-primary-color] {
              color: ${slider.thumb.primaryColor.active};
            }

            &:active [data-secondary-color] {
              color: ${slider.thumb.secondaryColor.active};
            }
          }
        }
      }
    `;
  }}
`;

export const NotchBlockContainer = styled.div`
  ${() => {
    const {
      tokens: { slider },
    } = useDesignTokens();

    return css`
      height: ${slider.thumb.size};
      width: 100%;
      display: flex;
      position: relative;

      &:before {
        height: ${slider.track.size};
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
    `;
  }}
`;

type NotchBlockProps = {
  $notchAsPercent: number;
};

export const NotchBlock = styled.div<NotchBlockProps>`
  ${({ $notchAsPercent }) => {
    const {
      tokens: { slider },
    } = useDesignTokens();

    return css`
      width: ${$notchAsPercent}%;
      border-right: ${slider.notch.size} ${slider.notch.color} solid;
    `;
  }};
`;

export const UIContainer = styled.div`
  width: 100%;
`;
type ArrowVisualState = "visible" | "hidden" | "notdisplayed";
type TooltipArrowProps = {
  $leftPercent: number;
  $visualState: ArrowVisualState;
};

export const TooltipArrow = styled.div<TooltipArrowProps>`
  ${({ $leftPercent, $visualState }) => {
    const { tokens } = useDesignTokens();
    const { tooltip, slider } = tokens;

    return [
      css`
        left: ${$leftPercent}%;
        position: relative;
        transform: translateX(-50%);

        width: 0;
        height: 0;
        border-left: ${slider.tooltip.arrowWidth} solid transparent;
        border-right: 12px solid transparent;

        border-bottom: 12px solid ${tooltip.backgroundColor};
      `,
      $visualState == "hidden" &&
        css`
          visibility: hidden;
        `,
      $visualState == "notdisplayed" &&
        css`
          display: none;
        `,
    ];
  }}
`;
